import { BUTTON_SIZES, DestructiveButton } from 'ui/button';
import { Body2 } from 'ui/theme';
import { Modal, ModalFooter, ModalBody, ModalHeader, MODAL_SIZES, MODAL_VARIANTS } from 'ui/modal';
import { useUpdateIngestionPolicies } from '../hooks';

export const TEXT = {
  ID: 'discard-event-modal',
  DESCRIPTION:
    'New instances of this event will not be stored, but the event will remain visible throughout the application and can still kick off actions like triggering journeys.',
  CONFIRM_BUTTON: 'Discard event',
};

export const headerText = (eventName: string) => `Discard ${eventName}?`;

type Props = {
  eventName: string;
  onClose: () => void;
};

export const DiscardEventModal = ({ onClose, eventName }: Props) => {
  const { discard } = useUpdateIngestionPolicies();

  const discardEvent = async () => {
    await discard(eventName);
  };

  return (
    <Modal
      id={TEXT.ID}
      isModalOpen={true}
      onClose={onClose}
      size={MODAL_SIZES.SMALL}
      variant={MODAL_VARIANTS.DELETE}
    >
      <ModalHeader>{headerText(eventName)}</ModalHeader>
      <ModalBody>
        <Body2>{TEXT.DESCRIPTION}</Body2>
      </ModalBody>
      <ModalFooter>
        <DestructiveButton onClick={discardEvent} size={BUTTON_SIZES.LARGE}>
          {TEXT.CONFIRM_BUTTON}
        </DestructiveButton>
      </ModalFooter>
    </Modal>
  );
};
